import script from "./ResearchAssignments.vue?vue&type=script&setup=true&lang=js"
export * from "./ResearchAssignments.vue?vue&type=script&setup=true&lang=js"

const __exports__ = script;

export default __exports__